import React, { useState, useEffect } from "react";

interface ICountdownTimerProps {
  label: string;
  duration: number;
  onExpire?: () => void;
  className?: string;
}

const CountdownTimer: React.FC<ICountdownTimerProps> = ({
  label,
  duration,
  onExpire,
  className
}) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    setTimeLeft(duration);
  }, [duration]);

  useEffect(() => {
    if (timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            onExpire?.();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [timeLeft, onExpire]);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
  const seconds = String(timeLeft % 60).padStart(2, "0");

  return (
    <div className={className}>
      <p>{label}</p>
      <p>
        {minutes}:{seconds}
      </p>
    </div>
  );
};

export default React.memo(CountdownTimer);
